module.exports = __webpack_public_path__ + "img/Kasasa_Edge_CC_Teal.ed47ccd1.png";